import './update-approval-type.less';
import React from 'react';
import { reduxForm, Field } from 'redux-form';

import SelectField from '../../../shared/form-elements/select/field';
import InputField from '../../../shared/form-elements/input';

const Form = props => (
	<form
		className="update-approval-type"
		onSubmit={props.handleSubmit(data => {
			props.updateType( props.requestId, data).then(() => props.setActiveRow(null));
		})}
	>
		<div className="control-bar-container">
			{
				props.activeField === 'type' &&
				<div className='banners-publication-editor-field'>
					<Field
						name='type'
						component={SelectField}
						searchable={false}
						options={props.requestTypes.map((c) => ({ value: c.id, label: c.text }))}
						placeholder={props.intl('Type')}
					/>
				</div>
			}
			{
				props.activeField === 'comment' &&
				<div className='banners-publication-editor-field'>
					<Field
						name='comment'
						component={InputField}
						placeholder={props.intl('Comment')}
					/>
				</div>
			}
		</div>
		<button type="submit" className="ui-btn ui-btn-primary save margin-top-15">
			{props.intl('Update')}
		</button>
		<button
			type="button"
			className="ui-btn ui-btn-cancel margin-top-15 margin-left-5"
			onClick={(e) => {
				e.stopPropagation();
				props.setActiveRow(null);
			}}
		>
			{props.intl('Close')}
		</button>
	</form>
);

export default reduxForm({ enableReinitialize: true })(Form);




// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/conversions-approve-requests/components/forms/update-approval-type.js